import React from 'react';
import { SPELL_EFFECT_EXAMPLES, spellEffectSummary, spellNeededTargets } from '../utils/spellEffect';

export function SpellEffectCard() {
  return (
    <div className="rule-form-card armor-formula-card spell-effect-card">
      <h3>Zauber-Effekte und mehrere Ziele</h3>
      <p className="section-info">
        Wie bei Tränken gilt ein Zauber-Status erst, wenn das Ziel getroffen wurde.
        Der Admin hebt ihn wieder auf. Brennen wartet, bis der Admin den Brandschaden
        auslöst. Mehrere Ziele stehen in der Formel; im Kampf klickt der Admin die
        Ziele in dieser Reihenfolge an.
      </p>
      <div className="spell-effect-examples">
        {SPELL_EFFECT_EXAMPLES.map((entry) => (
          <article key={entry.formula} className="spell-effect-example">
            <strong>{entry.label}</strong>
            <code>{entry.formula}</code>
            <small>
              {entry.hint} {spellNeededTargets(entry.formula) > 1
                ? `· ${spellNeededTargets(entry.formula)} Ziele`
                : ''}
            </small>
            <span className="spell-effect-preview">{spellEffectSummary(entry.formula)}</span>
          </article>
        ))}
      </div>
      <p className="section-info">
        Schreibweise: <code>N Ziel(e): …</code>, Klauseln mit Strichpunkt.
        Status: <code>Eingefroren</code>, <code>-2 Bewegung</code>, <code>Brennen 3</code>.
        Formeln in Klammern bleiben: <code>1 Ziel: {'{'}4+intelligence{'}'} Schaden, Brennen 2</code>.
        <code>{'{basisschaden}'}</code> ist nur die Schadensformel. <code>{'{schaden}'}</code> zählt Waffen und Buffs dazu.
      </p>
    </div>
  );
}
